<template lang="pug">
  Sample(:uuid="uuid", :type="type").Sample-mineral
    //- Ne pas supprimer
    div(slot="sample_features")
      p SAMPLE DETAILS (WAITING DATA)
</template>

<script>

import * as TYPE from '@/const.types'
import Sample from '@/views/Sample'

export default {
  name: 'sample-ore',
  props: ['uuid'],
  components: { Sample },
  computed: {
    type () {
      return TYPE.SAMPLE_MINERAL
    }
  }
}
</script>
